// src/components/DevicePanel/Map/MarkerManager/index.tsx

import React from "react";
import { Icon } from "leaflet";
import "./index.css";
import TrapMarker from "./Marker";
import { MarkerData } from "../../../types/components/map";

export interface MarkerManagerProps {
  markersData?: MarkerData[];
  defaultIcon?: Icon;
  renderPopup?: (marker: MarkerData) => React.ReactNode;
  map_center?: any;
}

const MarkerManager: React.FC<MarkerManagerProps> = ({ markersData = [] }) => {
  if (markersData.length === 0) return null;

  return (
    <>
      {markersData.map((marker, index) => (
        <TrapMarker marker={marker} key={`trap-${index}`} />
      ))}
    </>
  );
};

export default MarkerManager;
